import React from 'react';
import PropTypes from 'prop-types';
import {
  Card,
  CardContent,
  CardHeader,
  Divider,
  Table,
  TableBody,
  Typography
} from '@mui/material';
import { useTranslation } from 'react-i18next';

import useStyles from '../styles';
import DocumentAvalInfo from './DocumentAvalDetail';

const AvalDocuments = ({ aval, isDisabledEdit }) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <Card variant="elevation">
      <CardHeader
        className={classes.header}
        title={
          <Typography className={classes.tableCell} component="h4" variant="h4">
            {t('CLIENTS_VIEW.AVAL_DETAIL.AVAL_DOCUMENTS')}
          </Typography>
        }
      />
      <Divider className={classes.tableCell} />
      <CardContent style={{ padding: 0, marginBottom: '16px' }}>
        <Table>
          <TableBody>
            <DocumentAvalInfo aval={aval} isDisabledEdit={isDisabledEdit} />
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
};

AvalDocuments.propTypes = {
  aval: PropTypes.object,
  isDisabledEdit: PropTypes.bool
};

export default AvalDocuments;
